import authList from "./authList";
import publicList from "./publicList";

export const getRoutes = () => {
  return [...authList.list, ...publicList.list]
};
